import axios from "axios";
import apiUrl from "../apiURL";
import { toast } from "react-toastify";
import { getAuthToken } from "../auth/authService";
import axiosInstance from "../axiosInstance";

// Helper function to get a cookie by name
const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [key, value] = cookie.split("=");
    if (key === name) {
      return value;
    }
  }
  return null;
};

export const getAuthHeaders = () => {
  // Get access_token from cookies
  // const accessToken = getCookie('access_token');
  let accessToken = getAuthToken();
  accessToken = accessToken === "undefined" ? null : accessToken;

  // Add Authorization header if token exists
  const headers = accessToken
    ? { Authorization: `Bearer ${accessToken}` }
    : null;

  return headers;
};

export const getDeliveryAuthHeaders = () => {
  // Get access_token from cookies
  // const accessToken = getCookie('access_token');
  // const accessToken = getAuthToken();

  // Add Authorization header if token exists
  const headers = {
    Authorization: `Bearer eb91c37b78996b187673b871e53717c8857a58e1`,
  };

  return headers;
};

export const getDataFromCartToken = async (token) => {
  try {
    const response = await axiosInstance.get(apiUrl.cart.cartToken(token));
    if (response.status === 200) {
      // localStorage.setItem('cartData', JSON.stringify(response.data.data));
      console.log({ getDataFromCartToken: response.data });
      console.log("cart token api success");
      return { success: true, data: response.data.data };
    } else {
      console.log("cart token api failed");
      console.error("getDataFromCartToken:", response.status);
      return { success: false, message: "something went wrong" };
    }
  } catch (error) {
    console.log("cart token api error");
    console.log(error.stack, error.message);
    let msg = error?.response?.data?.message || "Something went wrong";
    return { success: false, message: msg };
  }
};

// Map to track ongoing requests per product to prevent race conditions
const ongoingRequests = new Map();

export const addUpdateCart = async (
  productId = "",
  productQty = "0",
  type = "add",
  setCartData,
  redirectToCart,
  abortSignal = null
) => {
  console.log(`[addUpdateCart] Called with:`, { productId, productQty, type })

  try {
    // Cancel any existing request for this product
    if (ongoingRequests.has(productId)) {
      const existingController = ongoingRequests.get(productId);
      console.log(`[addUpdateCart] Cancelling existing request for product:`, productId)
      existingController.abort();
    }

    // Create new abort controller for this request
    const controller = new AbortController();
    ongoingRequests.set(productId, controller);

    // Use provided abort signal or create new one
    const signal = abortSignal || controller.signal;

    const cartData = {
      productId: productId,
      quantity: productQty,
    };

    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      ongoingRequests.delete(productId);
      return null;
    }

    console.log(`[addUpdateCart] Making API request for:`, { productId, productQty })

    // await api.addToCart(cartData);
    const response = await axiosInstance.post(
      apiUrl.cart.updateCart,
      cartData,
      {
        headers,
        signal // Add abort signal to request
      }
    );

    // Clean up the request tracker
    ongoingRequests.delete(productId);

    console.log(`[addUpdateCart] API request completed for:`, productId)

    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      localStorage.setItem("cartData", JSON.stringify(response.data.data));
      if (setCartData) {
        setCartData(response.data.data);
      }
      if (productQty === 0 || productQty === "0") {
        // toast.success('Product removed from cart successfully!');
        console.log('Product removed from cart successfully');
      } else {
        // toast.success(`${type === 'add' ? 'Product added to cart successfully!' : 'Cart updated successfully!'}`);
        if (type === "add")
          if (redirectToCart)
            // toast.success('Product added to cart successfully!');
            window.location.href = window.location.origin + "/add-to-cart";
      }
      return response.data;
    }
  } catch (error) {
    // Clean up the request tracker
    ongoingRequests.delete(productId);

    // Don't show error for aborted requests
    if (error.name === 'AbortError' || error.name === 'CanceledError') {
      console.log('Request was cancelled for product:', productId);
      return null;
    }

    if (error?.response?.status !== 401) {
      // toast.error("Error updating to cart, please try again");
    }
    console.error("Error updating to cart:", error);
    // Return null to indicate failure
    return null;
  }
};

export const getCart = async () => {
  try {
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Check if coupon needs to be applied
    if (localStorage.getItem("couponNeedsToBeApplied") !== null) {
      // const storedCart = localStorage.getItem('cartData');

      // if (storedCart) {
      try {
        // const parsedCart = JSON.parse(storedCart);
        const couponCode = localStorage.getItem("couponNeedsToBeApplied");

        if (couponCode) {
          const response = await applyRemoveCoupon(couponCode, "getCart");
          if (response?.data?.data) {
            localStorage.setItem(
              "cartData",
              JSON.stringify(response.data.data)
            );
            console.log("Coupon applied/removed successfully.");
          }
        } else {
          console.warn("No coupon code found in cartData.");
        }
      } catch (err) {
        console.error("Error applying/removing coupon:", err);
      }
      // } else {
      //     console.warn("No cart data found in localStorage to apply coupon.");
      // }

      // Clear the flag so it doesn't reapply next time
      localStorage.removeItem("couponNeedsToBeApplied");
    }

    // Fetch cart after applying/removing coupon
    const response = await axiosInstance.get(apiUrl.cart.getCart, { headers });

    if (response.status === 200) {
      localStorage.setItem("cartData", JSON.stringify(response.data.data));
      return response.data;
    } else {
      console.warn(
        "Cart fetch responded with non-200 status:",
        response.status
      );
      return null;
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
    return null;
  }
};

export const applyRemoveCoupon = async (couponCode, ref = "") => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }
    // await api.addToCart(cartData);
    const response = await axiosInstance.get(
      apiUrl.cart.applyRemoveCouponCart(couponCode),
      { headers }
    );
    if (response.status === 200) {
      // console.log('coupon applied successfully', response.data);
      if (ref === "")
        toast.success(
          couponCode === null
            ? "Coupon removed successfully!"
            : response.data.data.price.message
        );
      // console.log('response.data', response.data)
      if (response.data.data.cartItem.length <= 0) {
        localStorage.setItem(
          "couponNeedsToBeApplied",
          response.data.data.price.couponCode
        );
      } else {
        localStorage.removeItem("couponNeedsToBeApplied");
      }
      localStorage.setItem("cartData", JSON.stringify(response.data.data));
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status !== 401 && ref === "") {
      // toast.error("Not able to update coupon. Please try again.");
    }
    console.error("Error updating to coupon on cart:", error);
  }
};

export const paymentVerification = async (
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature
) => {
  try {
    const response = await axiosInstance.post(apiUrl.cart.paymentVerification, {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
    });
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status !== 401)
      // toast.error("Not able to update coupon. Please try again.");
      console.error("Error updating to coupon on cart:", error);
  }
};

export const paymentFailed = async (
  order_id,
  error_code,
  error_description
) => {
  try {
    await axiosInstance.post(apiUrl.cart.paymentfailed, {
      order_id,
      error_code,
      error_description,
    });
    // if (response.status === 200) {
    //   return response.data;
    // }
    // toast.error("Payment Dismissed");
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("");
      console.error("Error updating to coupon on cart:", error);
  }
};

export const checkProductInCart = (productId) => {
  // console.log('productId', productId)
  if (productId) {
    try {
      const cartData = JSON.parse(localStorage.getItem("cartData")) || {};
      // console.log('cartData', cartData);
      if (cartData && cartData.cartItem) {
        const productInCart = cartData.cartItem.find(
          (item) => item.productId === productId
        );
        // console.log('productInCart', productInCart);
        return productInCart ? productInCart?.quantity : null;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error parsing cart data:", error);
      return null;
    }
  }
  return null;
};

export const checkProductInWishlist = (productId) => {
  if (productId) {
    try {
      const wishlistData =
        JSON.parse(localStorage.getItem("wishlistData")) || {};
      // console.log('wishlistData', wishlistData);
      if (wishlistData && wishlistData.product) {
        const productInWishlist = wishlistData.product.find(
          (item) => item.id === productId
        );
        // console.log('productInWishlist', productInWishlist);
        return productInWishlist ? true : false;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error parsing wishlist data:", error);
      return false;
    }
  }
  return false;
};
export const cartCheckout = async (
  shippingAddressId = "",
  billingAddressId = "",
  codOTP = "",
  phoneNumber = ""
) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Construct query parameters
    const params = {
      shippingAddressId: shippingAddressId,
      billingAddressId: billingAddressId,
      paymentMethod:
        localStorage.getItem("selectedPaymentOption") === "COD"
          ? "cod"
          : "online",
    };

    if (localStorage.getItem("selectedPaymentOption") === "COD") {
      params.codOtp = codOTP;
      params.phoneNumber = `91${phoneNumber}`;
    }

    const response = await axiosInstance.post(
      apiUrl.cart.cartCheckout,
      params,
      { headers }
    );
    return response.data;
  } catch (error) {
    console.log("error", error.response.data);
    if (error?.response?.status !== 401)
      if (error?.response?.data?.success === false) {
        // toast.error(error?.response?.data?.message);
      } else {
        // toast.error("Error while placing order, please try again");
      }
    console.error("Error during cart checkout:", error);
    return false;
  }
};

export const getWishlist = async () => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // await api.addToCart(cartData);
    const response = await axiosInstance.get(apiUrl.cart.getWishlist, {
      headers,
    });
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      localStorage.setItem("wishlistData", JSON.stringify(response.data.data));
      // setCartData(response.data.data);
      // toast.success('Product added to wishlist!');
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error, please try again");
      console.error("Error:", error);
  }
};

export const addWishlist = async (productId = "", setWishlistData) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // await api.addToCart(cartData);
    const response = await axiosInstance.get(
      apiUrl.cart.addRemoveFromWishlist(productId),
      { headers }
    );
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      localStorage.setItem("wishlistData", JSON.stringify(response.data.data));
      // setCartData(response.data.data);
      // toast.success('Product added to wishlist!');
      if (setWishlistData) {
        setWishlistData(response.data.data);
      }
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error, please try again");
      console.error("Error:", error);
  }
};

export const removeWishlist = async (productId = "", setWishlistData) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }
    const url = apiUrl.cart.addRemoveFromWishlist(productId);
    // await api.addToCart(cartData);
    const response = await axiosInstance.delete(url, { headers });
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      localStorage.setItem("wishlistData", JSON.stringify(response.data.data));
      // setCartData(response.data.data);
      // toast.success('Product removed from wishlist!');
      if (setWishlistData) {
        setWishlistData(response.data.data);
      }
      return response.data;
    }
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error, please try again");
      console.error("Error:", error);
  }
};

export const getAddresses = async () => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.get(apiUrl.address.getAddAddress, {
      headers,
    });
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      localStorage.setItem("addresses", JSON.stringify(response.data.data));
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
};

export const addAddress = async (payload) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.post(
      apiUrl.address.getAddAddress,
      payload,
      { headers }
    );
    // console.log('response', response);
    if (response.data.success) {
      // console.log('cart fetched successfully', response.data);
      // toast.success(response.data.message);
      localStorage.setItem("addresses", JSON.stringify(response.data.data));
      return true;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error adding address!");
      console.error("Error adding address:", error);
    return false;
  }
};

export const updateAddress = async (payload, addressId) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.patch(
      apiUrl.address.updateAddress(addressId),
      payload,
      { headers }
    );
    // console.log('response', response);
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      // toast.success(response.data.message);
      localStorage.setItem("addresses", JSON.stringify(response.data.data));
      return true;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error updating address!");
      console.error("Error updating address:", error);
    return false;
  }
};

export const updateProfile = async (payload) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.patch(
      apiUrl.profile.updateProfile,
      payload,
      { headers }
    );
    // console.log('response', response);
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      // toast.success(response.data.message);
      localStorage.setItem("u_info", JSON.stringify(response.data.data));
      return response.data.data;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error updating profile!");
      console.error("Error updating profile:", error);
    return false;
  }
};

export const makeAddDefault = async (addressId) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    const payload = {
      isDefault: true,
    };

    // Pass headers as part of the options object
    const response = await axiosInstance.patch(
      apiUrl.address.makeAddDefault(addressId),
      payload,
      { headers }
    );
    // console.log('response', response);
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      // toast.success(response.data.message);
      // localStorage.setItem('addresses', JSON.stringify(response.data.data));
      return true;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error updating address!");
      console.error("Error updating address:", error);
    return false;
  }
};

export const removeAddress = async (addressId) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.delete(
      apiUrl.address.deleteAddress(addressId),
      { headers }
    );
    // console.log('response', response);
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      // toast.success(response.data.message);
      // localStorage.setItem('addresses', JSON.stringify(response.data.data));
      return true;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error updating address!");
      console.error("Error updating address:", error);
    return false;
  }
};

export const getCouponList = async () => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Pass headers as part of the options object
    const response = await axiosInstance.get(apiUrl.cart.getCouponList, {
      headers,
    });
    if (response.status === 200) {
      // console.log('cart fetched successfully', response.data);
      // localStorage.setItem('cartData', JSON.stringify(response.data.data));
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
};

function formatDateToDDMMMYYYY(dateString) {
  const date = new Date(dateString);

  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
    .format(date)
    .replace(/ /g, "-");
}

export const checkDeliveryEstimate = async (
  pinCode,
  setDeliveryEstimateHelperText,
  setDeliveryInputState,
  setDeliveryResponse
) => {
  try {
    // Get the Authorization headers
    // const headers = getDeliveryAuthHeaders();
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // await api.addToCart(cartData);
    const response = await axios.get(apiUrl.cart.deliveryStatus(pinCode), {
      headers,
    });
    // console.log('response pincode', { response: response.data });
    const { estimate, pincode, message } = response.data;
    if (response.status === 200) {
      localStorage.setItem("selected_pincode", pinCode);
      let temp = response.data;
      // temp.pincode.delivery_codes[0].postal_code.pre_paid = "N"
      if (setDeliveryResponse) setDeliveryResponse(temp);
      if (
        pincode?.delivery_codes?.length > 0 &&
        estimate?.data?.expected_delivery_date &&
        pincode?.delivery_codes?.[0]?.postal_code?.remarks.toLowerCase() !==
        "embargo"
      ) {
        setDeliveryEstimateHelperText(
          `The estimated delivery date is ${formatDateToDDMMMYYYY(
            estimate?.data?.expected_delivery_date
          )}`
        );
      } else if (message === "Pincode not found") {
        setDeliveryEstimateHelperText("Pincode is not servicable");
      } else {
        setDeliveryEstimateHelperText("Pincode is not servicable");
      }
      if (setDeliveryInputState) setDeliveryInputState(false);
    }
  } catch (error) {
    // if (error?.response?.status !== 401)
    //   toast.error("Not able to check delivery estimate. Please try again.");
  }
};

// Helper function to validate pin code serviceability
export const validatePinCodeServiceability = async (pinCode) => {
  try {
    const headers = getAuthHeaders();
    if (!headers) {
      return { isServiceable: false, message: "Authentication required" };
    }

    const response = await axios.get(apiUrl.cart.deliveryStatus(pinCode), {
      headers,
    });

    const { estimate, pincode, message } = response.data;

    if (response.status === 200) {
      const isServiceable = pincode?.delivery_codes?.length > 0 &&
        estimate?.data?.expected_delivery_date &&
        pincode?.delivery_codes?.[0]?.postal_code?.remarks.toLowerCase() !== "embargo";

      return {
        isServiceable,
        message: isServiceable
          ? `Delivery available by ${formatDateToDDMMMYYYY(estimate?.data?.expected_delivery_date)}`
          : "Pincode is not servicable"
      };
    }

    return { isServiceable: false, message: "Unable to validate pincode" };
  } catch (error) {
    console.error("Error validating pincode:", error);
    return { isServiceable: false, message: "Unable to validate pincode" };
  }
};

export const otpSent = async (payload, otpResent = false) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    const url = otpResent ? apiUrl.cart.resendOtp : apiUrl.cart.otpSent;

    // Pass headers as part of the options object
    const response = await axiosInstance.post(url, payload, { headers });
    if (response.data.success) {
      return response.data;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) // toast.error("Error adding address!");
      console.error("Error adding address:", error);
    return false;
  }
};

export const retryPayment = async (orderId) => {
  try {
    // Get the Authorization headers
    const headers = getAuthHeaders();
    if (!headers) {
      return null;
    }

    // Create retry payment request
    const response = await axiosInstance.post(
      apiUrl.cart.retryPayment(orderId),
      {},
      { headers }
    );

    if (response.status === 200) {
      return response.data;
    }
    return false;
  } catch (error) {
    if (error?.response?.status !== 401) {
      // toast.error("Error retrying payment. Please try again.");
    }
    console.error("Error retrying payment:", error);
    return false;
  }
};
